<div class="card-header">
  <div class="title-section">
    <h5 class="header-title">{{ model ? 'Editar' : 'Nuevo' }} Estatus</h5>
  </div>
  <div class="button-section">
    <button
      mat-flat-button
      (click)="model ? update(form.value) : create(form.value)"
      class="{{ model ? 'btn-edit' : 'btn-success' }}"
      [disabled]="!form.valid || loading"
      appPermissionControl="P120B0002"
    >
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="model" mat-flat-button (click)="openCustomizables()" class="btn-search" appPermissionControl="P120B0006">
      <mat-icon>settings</mat-icon>
      Customizables
    </button>
    <button
      *ngIf="model"
      mat-flat-button
      class="btn-back"
      (click)="openSubestatusDialog()"
    >
      <mat-icon>add</mat-icon>
      Subestatus
    </button>
    <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P120B0001">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="model ? update(form.value) : create(form.value)" appPermissionControl="P120F0001">
  <div class="form-row mt-3">
    <div class="form-field mt-1">
      <p-dropdown
        [options]="Empresas"
        formControlName="sEmpresa"
        optionLabel="sNombre"
        optionValue="sEmpresa"
        [placeholder]="'Seleccione empresa'"
        [filter]="true"
        appPermissionControl="P120K0001"
      >
        <ng-template pTemplate="item" let-empresa>
          <div class="p-d-flex p-ai-center">
            <span>{{ empresa.sNombre }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <label>Empresa</label>
      <small class="p-error" *ngIf="form.get('sEmpresa')?.errors?.required && form.get('sEmpresa')?.touched"> Campo requerido </small>
    </div>

    <div class="form-field">
      <input pInputText type="text" formControlName="codigoEstado" class="form-control" [placeholder]="'Ingrese código estado'" appPermissionControl="P120K0002" />
      <label>Código Estado</label>
      <small class="p-error" *ngIf="form.get('codigoEstado')?.errors?.required && form.get('codigoEstado')?.touched"> Campo requerido </small>
      <small class="p-error" *ngIf="form.get('codigoEstado')?.errors?.singleCodigo"> Código en uso </small>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field flex-grow-1">
      <input pInputText type="text" formControlName="descripcion" class="form-control" [placeholder]="'Ingrese descripción'" appPermissionControl="P120K0003" />
      <label>Descripción</label>
      <small class="p-error" *ngIf="form.get('descripcion')?.errors?.required && form.get('descripcion')?.touched"> Campo requerido </small>
    </div>
  </div>
</form>

<ng-container *ngIf="!selectEmpresa">
  <button mat-button color="accent" class="buttonBack" type="button" (click)="buscarEmpresas()" appPermissionControl="P120B0005"><mat-icon>west</mat-icon> Regresar</button>
  <app-select-empresa></app-select-empresa>
</ng-container>

<!-- Diálogo de Subestatus -->
<p-dialog
  [(visible)]="displaySubestatusDialog"
  [style]="{ width: '70vw' }"
  [contentStyle]="{ padding: '1rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="hideSubestatusDialog()"
  header="{{ model?.descripcion }} - {{ model?.codigoEstado }}"
>
  <div class="card-header mb-3">
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dtSubestatus.filterGlobal($event.target.value, 'contains')"
            placeholder="Buscar..."
          />
        </span>
      </div>
      <button mat-flat-button class="btn-new" type="button" (click)="openNewSubestatusDialog()">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
    </div>
  </div>

  <p-table
    #dtSubestatus
    [value]="subestatusDataSource"
    [columns]="subestatusColumns"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="300px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    appendTo="body"
    [loading]="subestatusLoading"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" class="th-prime">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="editSubestatus(rowData)"
                ></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteSubestatus(rowData)"
                ></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="subestatusColumns.length" class="text-center td-prime">
          No hay subestatus para mostrar
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- Diálogo Nuevo Subestatus -->
<p-dialog
  [(visible)]="displaySubestatusFormDialog"
  [style]="{ width: '420px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="hideSubestatusFormDialog()"
  [header]="subestatusDialogMode === 'edit' ? 'Editar Subestatus' : 'Nuevo Subestatus'"
>
  <form [formGroup]="subestatusForm">
    <div class="form-row">
      <div class="form-field flex-grow-1">
        <input pInputText type="text" formControlName="compania" class="w-100" readonly />
        <label>Compañía</label>
      </div>
      <div class="form-field flex-grow-1">
        <input pInputText type="text" formControlName="estatusCredito" class="w-100" readonly />
        <label>Estatus Crédito</label>
      </div>
      <div class="form-field flex-grow-1">
        <input pInputText type="text" formControlName="subEstatusCredito" class="w-100" />
        <label>Sub Estatus Crédito</label>
      </div>
      <div class="form-field flex-grow-1">
        <input pInputText type="text" formControlName="descripcion" class="w-100" />
        <label>Descripción</label>
      </div>
    </div>

    <div class="button-section mt-3">
      <button
        mat-flat-button
        class="btn-success btn-menu"
        type="button"
        (click)="saveSubestatus()"
        [disabled]="subestatusForm.invalid || subestatusFormSubmitting"
      >
        <mat-icon>save</mat-icon>
        {{
          subestatusFormSubmitting
            ? (subestatusDialogMode === 'edit' ? 'Actualizando...' : 'Guardando...')
            : (subestatusDialogMode === 'edit' ? 'Actualizar' : 'Guardar')
        }}
      </button>
    </div>
  </form>
</p-dialog>

<p-toast position="bottom-right" />